module.exports = __webpack_public_path__ + "static/img/cont61_03.584cfa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61_03.jpg
// module id = Nzej
// module chunks = 0